import { render, staticRenderFns } from "./subjectMatterInfo.vue?vue&type=template&id=7b19d8fe&scoped=true&"
import script from "./subjectMatterInfo.vue?vue&type=script&lang=js&"
export * from "./subjectMatterInfo.vue?vue&type=script&lang=js&"
import style0 from "./subjectMatterInfo.vue?vue&type=style&index=0&id=7b19d8fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b19d8fe",
  null
  
)

export default component.exports